import React, { PropTypes, Component } from 'react';
import { Checkbox, Form, Input } from 'semantic-ui-react';

class MultiReferenceCheckbox extends Component {
  constructor(props) {
    super(props);

    this.onRefChange = this.onRefChange.bind(this);
  }

  onRefChange(event, data) {
    const newItem = data.value;

    let values = [];
    if (this.props.values) {
      values = this.props.values;
    }

    if (data.checked) {
      this.props.onChangeValues(event, { value: values.concat(newItem) });
    } else {
      this.props.onChangeValues(event, {
        value: values.filter(item => item !== newItem),
      });
    }
  }

  render() {
    const {
      references,
      label,
      values,
      onChangeOther,
      otherValue,
      withOther,
      readOnly,
    } = this.props;

    const isChecked = id => values && values.includes(id);

    const otherChecked = otherValue => {
      if (otherValue === null || otherValue === undefined) {
        return false;
      } else {
        return true;
      }
    };

    const onOtherClicked = (event, data) => {
      if (data.checked) {
        onChangeOther(event, { value: '' });
      } else {
        onChangeOther(event, { value: undefined });
      }
    };

    return (
      <div className="field">
        <label>{label}</label>
        <Form.Group inline className="ui grid checkBoxList">
          {references &&
            references.map(ref => {
              return (
                <Form.Field key={ref.id} width={4} className="column">
                  <Checkbox
                    label={ref.label}
                    value={ref.id}
                    onChange={this.onRefChange}
                    checked={isChecked(ref.id)}
                    readOnly={readOnly}
                  />
                </Form.Field>
              );
            })}
        </Form.Group>
        {withOther && (
          <Form.Group inline className="ui grid checkBoxList one">
            <Form.Field key="other">
              <Checkbox
                label="Autre"
                checked={otherChecked(otherValue)}
                onChange={onOtherClicked}
                readOnly={readOnly}
              />
            </Form.Field>
            <Form.Field width={8}>
              <Input
                value={otherValue || ''}
                onChange={onChangeOther}
                disabled={!otherChecked(otherValue)}
                readOnly={readOnly}
              />
            </Form.Field>
          </Form.Group>
        )}
      </div>
    );
  }
}

MultiReferenceCheckbox.PropTypes = {
  label: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  otherValue: PropTypes.string,
  references: PropTypes.array.isRequired,
  onChangeValues: PropTypes.func.isRequired,
  onChangeOther: PropTypes.func.isRequired,
  withOther: PropTypes.bool.isRequired,
};

export default MultiReferenceCheckbox;



// WEBPACK FOOTER //
// ./src/modules/common/components/MultiReferenceCheckbox.js